






































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class Pagenation extends Vue {
  // ------------------------------------------------------------------------------------------------
  // props
  // ページャー対象
  @Prop() private items!: []
  // １ページあたりの表示件数
  @Prop() private size!: number
  // 初期表示位置（任意）
  @Prop({ default: 0 }) private startPage!: number
  // １回あたりの最大ページネーション（任意）
  @Prop({ default: 5 }) private pageRange!: number
  // ページ移動時のアンカー（任意）
  @Prop({ default: '#' }) private anchor!: string
  // Firstページ・Endページに遷移するボタン表示
  @Prop({ default: false }) private viewFirstEnd!: boolean

  // ------------------------------------------------------------------------------------------------
  // data
  private currentPage = 0
  private windowWidth = window.innerWidth
  private moblieBreakPoint = 768

  constructor() {
    super()
    this.currentPage = this.startPage ?? 0
  }

  // ------------------------------------------------------------------------------------------------
  // hooks
  private mounted() {
    window.addEventListener('resize', this.handleResize)
  }

  private beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }

  // ---------------------------------------------------------------------------
  // computed
  get pages(): number {
    return Math.ceil(this.items.length / this.size)
  }

  get displayPageRange(): number[] {
    const half = Math.ceil(this.pageRange / 2)
    let start, end

    if (this.pages < this.pageRange) {
      // ページネーションのrangeよりページ数がすくない場合
      start = 1
      end = this.pages
    } else if (this.currentPage < half) {
      // 左端のページ番号が1になったとき
      start = 1
      end = start + this.pageRange - 1
    } else if (this.pages - half < this.currentPage) {
      // 右端のページ番号が総ページ数になったとき
      end = this.pages
      start = end - this.pageRange + 1
    } else {
      // activeページを中央にする
      start = this.currentPage - half + 1
      end = this.currentPage + half
    }

    const indexes = []
    for (let i = start; i <= end; i++) {
      indexes.push(i)
    }
    return indexes
  }

  get anchorTag(): string {
    return '#' + this.anchor.replace('#', '')
  }

  get isMobile(): boolean {
    return this.windowWidth < this.moblieBreakPoint
  }
  // ---------------------------------------------------------------------------
  // methods

  private selectHandler() {
    this.$emit('pageMove', this.currentPage)
  }

  private first() {
    this.currentPage = 0
    this.selectHandler()
  }

  private last() {
    this.currentPage = this.pages - 1
    this.selectHandler()
  }

  private prev() {
    if (this.currentPage > 0) {
      this.currentPage--
      this.selectHandler()
    }
  }

  private next() {
    if (this.currentPage < this.pages - 1) {
      this.currentPage++
      this.selectHandler()
    }
  }

  private pageSelect(index: number) {
    this.currentPage = index - 1
    this.selectHandler()
  }

  private handleResize() {
    this.windowWidth = window.innerWidth
  }

  // ---------------------------------------------------------------------------
  // watch
  @Watch('items', { deep: true })
  private handler() {
    this.first()
  }
}
